(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
  const customProductTabs = document.querySelector('.custom-product-tabs');

  if (customProductTabs) {
    const tabs = customProductTabs.querySelectorAll('li.custom-tab-button');
    const tabContents = customProductTabs.querySelectorAll('.custom-tab-content');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetContentId = tab.getAttribute('tab-content-id');

        tabs.forEach((t) => t.classList.remove('active'));
        tabContents.forEach((c) => {
          c.classList.remove('active');
          c.style.display = 'none';
        });

        tab.classList.add('active');

        const targetContent = document.getElementById(targetContentId);
        if (targetContent) {
          targetContent.style.display = 'block';
          setTimeout(() => {
            targetContent.classList.add('active');
          }, 10);
        }
      });
    });

    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const activeTabContent = customProductTabs.querySelector('.custom-tab-content.active');
        if (activeTabContent) {
          activeTabContent.style.display = 'block';
          activeTabContent.style.opacity = '1';
          activeTabContent.style.transform = 'translateY(0)';
        }
      },
      { once: true },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
